import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../../core/auth/services/config.service';
import { Observable } from 'rxjs';
import { AssessmentEligibility, AssessmentEligibilityApiResponse } from '../components/dashboard-const/dashboard-model';

export interface AssessmentData {
  pre_assessment_id: string;
  last_assessment_date: string;
  latest_score: string | number; // Handling both cases
}

export interface BmiData {
  bmi_value: number;
  height: string;
  weight: string;
}

export interface HydrationData {
  tracting_id: string;
  todays_goal: number;
  todays_intake: number;
  weekly_avg: number;
  weekly_goal: number;
}

export interface DashboardStats {
  assessment_data: AssessmentData;
  bmi_data: BmiData;
  hydration_data: HydrationData;
}

export interface DashboardResponse {
  status: number;
  message: string;
  type: string;
  correlationId: string;
  data: DashboardStats;
}

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

    private httpClient = inject(HttpClient);
    private configService = inject(ConfigService);
    private baseUrl = this.configService.getPatientAPIUrl();
    private apiUrl = this.configService.getAPIUrl(); // v2

  constructor() { }

  getDashboardStats(patient_id :string): Observable<DashboardResponse> {
    return this.httpClient.get<DashboardResponse>(`${this.apiUrl}/api/patientstatistics?patient_id=${patient_id}`); // Assuming endpoint
  }

  logHydration(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/api/WaterTracking/LogConsumption`, data);
  }

  getPreAssementEleigibility(patient_id: string): Observable<AssessmentEligibilityApiResponse> {
    return this.httpClient.get<AssessmentEligibilityApiResponse>(`${this.apiUrl}/api/preassessment/eligibility?patient_id=${patient_id}`);
  }
}
